export const version = 'v2.2.4-1988-g3fe5e1cbe'
